import { C } from '../../theme/palette';

/** Pastille d'un métier, cochée ou non. */
export const pastille = (coche) => ({
  padding: '8px 12px',
  borderRadius: 10,
  fontSize: 11,
  fontWeight: 700,
  cursor: 'pointer',
  border: '1.5px solid ' + (coche ? C.teal : C.border),
  background: coche ? C.teal : '#fff',
  color: coche ? '#fff' : C.ink,
});
